export const resolveAllAvailability = (page = undefined, perpage = undefined, deleted = undefined, type) => {
    return ['availabilityModelService', availabilityModelService => {
        return availabilityModelService.findAll({
            page: page,
            per_page: perpage,
            deleted: deleted,
            ruletype: type
        }).then(list => list);
    }];
};

export const resolveAvailability = (param = 'availability') => {
    return ['$stateParams', 'availabilityModelService', ($stateParams, availabilityModelService) => {
        return $stateParams[param] && $stateParams[param] > 0 ? availabilityModelService.findById($stateParams[param], {
            ruletype: $stateParams.type
        }) : {};
    }];
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/availability/resolvers/availability.resolver.js